import { useQuery } from '@tanstack/react-query'
import { config } from '@/config'
import {
  ADP_DATA_SOURCES_FILTER_COLUMN_SOURCE,
  ADP_DATA_SOURCES_FILTER_COLUMN_TARGET_DESTINATION,
  fetchAdpDataSourcesFilter,
} from '@/features/adp/api/adpDataSources.api'
import { bucketAdpDataSources, type BucketedPaletteConnectors } from '@/features/adp/api/dataSourcePaletteBuckets'
import type { AdpDataSource } from '@/features/adp/api/adpDataSources.types'

/**
 * Which side of the pipeline the palette is for.
 * - `source` → API `is_supported_for_source_data_source`
 * - `destination` → API `is_supported_for_target_data_source` (target / output connectors)
 */
export type AdpPaletteDataSourceRole = 'source' | 'destination'

const FILTER_COLUMN_BY_ROLE: Record<AdpPaletteDataSourceRole, string> = {
  source: ADP_DATA_SOURCES_FILTER_COLUMN_SOURCE,
  destination: ADP_DATA_SOURCES_FILTER_COLUMN_TARGET_DESTINATION,
}

export function useAdpPaletteDataSources(role: AdpPaletteDataSourceRole) {
  return useQuery<AdpDataSource[], Error, BucketedPaletteConnectors>({
    queryKey: ['adp', 'data-sources', 'palette', role],
    queryFn: () =>
      fetchAdpDataSourcesFilter({
        column_name: FILTER_COLUMN_BY_ROLE[role],
        value: true,
        show_schema_definition: true,
        show_prerequisite: true,
      }),
    select: data => bucketAdpDataSources(data, config.adpApiUrl),
    staleTime: 60_000,
  })
}
